import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const eventThrottleUiNodeSpec: NodeSpec<NodeCfg<'eventThrottle'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { max: 1, windowMs: 200 }, id: getUID(), kind: 'eventThrottle', disabled: false }),
    controls: nodeCfg => ({
        max: defineControlOpts({
            cfg: { kind: 'number', label: 'Max', min: 1 },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.max,
        }),
        windowMs: defineControlOpts({
            cfg: { kind: 'number', label: 'Window (ms)', min: 0 },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.windowMs,
        }),
    }),
    inputs: () => ({ input: { socket: 'event', label: 'Input' } }),
    kindLabel: 'Event Throttle',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
